import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgBell = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='m6.106 6.92-.829 4.556a15.4 15.4 0 0 1-.852 2.962l-.876 2.19A1 1 0 0 0 4.477 18H12a1 1 0 1 1-.866 1.5 1 1 0 1 0-1.732 1 3 3 0 0 0 5.427-2.5h4.694a1 1 0 0 0 .928-1.371l-.876-2.19a15.4 15.4 0 0 1-.852-2.963l-.828-4.557a5.991 5.991 0 0 0-11.79 0M12 3.75a1 1 0 1 0 0 2c1.083 0 2.011.775 2.205 1.84a1 1 0 0 0 1.968-.358A4.24 4.24 0 0 0 12 3.75'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgBell)
export default ForwardRef
